import { Util } from './_util.js';

import { gsap, ScrollTrigger, ScrollToPlugin, MotionPathPlugin, TweenMax, DrawSVGPlugin } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

gsap.registerPlugin(ScrollToPlugin);

const Animations = {
  sideMenu: function () {
    const menuIconTl = gsap.timeline({ paused: true });

    // Close the side menu if it's open on page load
    const sideMenu = document.querySelector('.side-menu');

    const menuItems = document.querySelectorAll('#primary-menu ul li');

    $('.menu-icon').on('click', function () {
      $('#site-navigation').toggleClass('menu-active');
      menuIconTl.reversed(!menuIconTl.reversed());

      $('#primary-menu').removeClass('active');
      $('.parent-menu').removeClass('active');

      if (!Util.isMobile()) {
        $('.menu-active .parent-menu').removeClass('active');
      }

      $('.banner').toggleClass('menu-active');

      //side menu animation
      if (!sideMenu.classList.contains('show')) {
        showElement();
      } else {
        sideMenu.classList.remove('show'); // Remove the class controlling visibility
        sideMenu.style.display = 'none'; // Remove it from the document flow
      }
    });
    function showElement() {
      sideMenu.style.display = 'block'; // Ensure the side menu is visible
      sideMenu.classList.add('show'); // Add the `show` class

      gsap.fromTo(
        menuItems,
        { opacity: 0, y: 6 }, // Start state
        {
          opacity: 1,
          y: 0, // End state
          stagger: 0.03, // Stagger animation by 0.1 seconds
          //duration: 0.3,
          ease: 'power2.inOut',
        }
      );
    }

    function hideElement() {
      $('#site-navigation').removeClass('menu-active');
      menuIconTl.reversed(!menuIconTl.reversed());

      $('#primary-menu').removeClass('active');
      $('.parent-menu').removeClass('active');

      if (!Util.isMobile()) {
        $('.menu-active .parent-menu').removeClass('active');
      }
      sideMenu.classList.remove('show'); // Remove the class controlling visibility
      sideMenu.style.display = 'none'; // Remove it from the document flow
      $('.banner').removeClass('menu-active');
    }

    // Add this new click handler after the hideElement function
    $('.images').on('click', function () {
      hideElement();
    });

    // Submenu click event
    $('.parent-menu .sub-menu a').on('click', function (event) {
      const targetHref = $(this).attr('href');
      const targetBasePath = targetHref.split('#')[0];
      const currentBasePath = window.location.pathname;

      hideElement();

      console.log('Current Base Path:', currentBasePath); // Log the current base path
      console.log('Target Href:', targetHref); // Log the target href
      if (currentBasePath === '/shop/' && targetHref.includes('#gifts-and-curated-sets')) {
        // Update the URL and then force refresh the page
        event.preventDefault();
        window.location.href = targetHref; // Update the URL
        window.location.reload(); // Reload the page
      } else if (currentBasePath === '/blog/' && targetHref.includes('#')) {
        // Update the URL and then force refresh the page
        event.preventDefault();
        window.location.href = targetHref; // Update the URL
        window.location.reload(); // Reload the page
      } else if (currentBasePath === targetBasePath && targetHref.includes('#')) {
        event.preventDefault();
        const anchor = targetHref.split('#')[1];
        const targetElement = document.getElementById(anchor);

        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      } else {
        sessionStorage.setItem('scrollToAnchor', targetHref.split('#')[1]);
      }

      // Add 'active' class to the corresponding .sub-nav link
      // $('.sub-navs a').removeClass('active'); // Remove active class from all .sub-nav links
      // $(`.sub-navs a[href="#${targetHref.split('#')[1]}"]`).addClass('active'); // Add active class to the corresponding .sub-nav link

      $('#site-navigation').toggleClass('menu-active');
      menuIconTl.reversed(!menuIconTl.reversed());
      $('#primary-menu').removeClass('active');
      $('.parent-menu').removeClass('active');

      if (!Util.isMobile()) {
        $('.menu-active .parent-menu').removeClass('active');
      }
    });

    $(document).on('keydown', function (e) {
      if (e.key === 'Escape') {
        // Check if the "Escape" key is pressed
        hideElement();
        if ($('#site-navigation').hasClass('menu-active')) {
          $('#site-navigation').removeClass('menu-active');
          $('.parent-menu').removeClass('active');
          menuIconTl.reversed(!menuIconTl.reversed());

          $('body').removeClass('no-scroll');
        }
      }
    });

    const menuLine1 = document.querySelectorAll('.menu-icon svg .line-1');
    const menuLine2 = document.querySelectorAll('.menu-icon svg .line-2');
    const menuSVG = document.querySelectorAll('.menu-icon svg');

    menuIconTl.to(menuSVG, { height: 40, y: -8, duration: 0.4 }, 0);
    menuIconTl.to(menuLine1, { attr: { y2: 20, y1: 4 }, duration: 0.4 }, 0);
    // menuIconTl.to( menuLine2, {attr:{x1: -10, x2: -50}, duration: .4 }, 0)
    menuIconTl.to(menuLine2, { attr: { y2: 4, y1: 20.9, x2: 17 }, duration: 0.4 }, 0).reverse();

    if (!Util.isMobile() && !Util.isTablet()) {
      $('.parent-menu').on('click', function () {
        hideElement();
      });

      $(document).ready(function () {
        let activeLink = null; // Variable to store the currently active link

        $('#primary-menu .parent-menu > a').hover(
          function () {
            // On hover, remove not-hovered and add hovered classes
            $('#primary-menu .parent-menu > a').removeClass('not-hovered hovered');
            $('#primary-menu .parent-menu > a').parent().removeClass('not-hovered hovered');

            $('#primary-menu .parent-menu > a').not(this).addClass('not-hovered');
            $('#primary-menu .parent-menu > a').not(this).parent().addClass('not-hovered');
            $(this).addClass('hovered');
            $(this).parent().addClass('hovered');

            // Get the index of the hovered link
            var index = $('#primary-menu .parent-menu > a').index(this);

            // Hide all images (set opacity to 0)
            $('.images .img-wrapper').css('opacity', 0);

            // Show the corresponding image (set opacity to 1)
            $('.images .img-wrapper').eq(index).css('opacity', 1);

            // Update the active link
            activeLink = $(this);
          },
          function () {
            // Do nothing on hover out
          }
        );

        $('.side-menu').on('mouseleave', function () {
          // If the mouse leaves the menu, keep the active link highlighted
          if (activeLink) {
            $('#primary-menu .parent-menu > a').removeClass('hovered not-hovered');
            $('#primary-menu .parent-menu').removeClass('hovered not-hovered');
            //activeLink.addClass('hovered');
            //activeLink.parent().addClass('hovered');

            // Show the corresponding image for the active link
            var index = $('#primary-menu .parent-menu > a').index(activeLink);
            $('.images .img-wrapper').css('opacity', 0);
            $('.images .img-wrapper').eq(index).css('opacity', 1);
          }
        });
      });
    } else {
      //console.log('is mobile or tablet');
      //$('.menu-item-has-children > a').removeAttr("href");
      $('.parent-menu').on('click', function () {
        if ($(this).hasClass('active')) {
          $(this).toggleClass('active');
        } else {
          $('#primary-menu .parent-menu').removeClass('active');
          $(this).toggleClass('active');
        }

        $(this).parent().addClass('active');
      });

      $('.parent-menu a').on('click', function () {
        hideElement();
      });
    }
  },

  headerAnimation: function () {
    if (!Util.isMobile()) {
      if ($('.js-headerAnim-bt')[0]) {
        gsap.utils.toArray('.js-headerAnim-bt').forEach((headerBT) => {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: headerBT,
              start: '-100% bottom',
              //end: 'center 30%',
              //markers: true,
              //scrub: 1,
            },
          });

          tl.fromTo(headerBT, { y: 30, opacity: 0 }, { ease: 'ease-in', y: 0, opacity: 1, duration: 1 });
        });
      }
      if ($('.js-headerAnim-tb')[0]) {
        gsap.utils.toArray('.js-headerAnim-tb').forEach((headerTB) => {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: headerTB,
              start: 'top bottom',
              //end: 'center center',
              //markers: true,
              //scrub: 1,
            },
          });

          tl.fromTo(headerTB, { y: -30, opacity: 0 }, { ease: 'ease-in', y: 0, opacity: 1, duration: 2 });
        });
      }
    }
  },
  fadeIn: function () {
    if ($('.js-fadeIn')[0]) {
      gsap.utils.toArray('.js-fadeIn').forEach((fadeIn) => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: fadeIn.parentElement,
            start: 'top 60%',
            //markers: true
          },
        });

        tl.fromTo(fadeIn, { opacity: 0, y: 30 }, { ease: 'ease-in', opacity: 1, duration: 1, y: 0 });
      });
    }

    if ($('.js-selfFadeIn')[0]) {
      gsap.utils.toArray('.js-selfFadeIn').forEach((selfFadeIn) => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: selfFadeIn,
            start: 'top 70%',
            //markers: true
          },
        });

        tl.fromTo(selfFadeIn, { opacity: 0, y: 30 }, { ease: 'ease-in', opacity: 1, duration: 1, y: 0 });
      });
    }
    if ($('.js-selfSlowFadeIn')[0]) {
      gsap.utils.toArray('.js-selfSlowFadeIn').forEach((selfSlowFadeIn) => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: selfSlowFadeIn,
            start: 'top 60%',
            //markers: true
          },
        });

        tl.fromTo(selfSlowFadeIn, { opacity: 0, y: 30 }, { ease: 'ease-in', opacity: 1, duration: 1.5, y: 0 });
      });
    }
  },
  subNav: function () {
    if ($('.js-subNav')[0]) {
      function insertAfter(newNode, referenceNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
      }

      const subnav = gsap.utils.toArray('.js-subNav');
      subnav.forEach((btn) => {
        const originalParent = btn.parentNode; // Store the original parent
        console.log(originalParent);
        gsap.from(btn, {
          scrollTrigger: {
            start: 'top top',
            end: 'bottom center',
            trigger: btn,
            endTrigger: '.footer',
            toggleClass: 'fixed',
            onEnter: () => {
              document.getElementById('smooth-wrapper').parentNode.appendChild(btn);
            },
            onEnterBack: () => {
              document.getElementById('smooth-wrapper').parentNode.appendChild(btn);
            },
            onLeave: () => {
              if (btn.classList.contains('wine-pdp')) {
                insertAfter(btn, document.querySelector('.section--wines-banner'));
              } else if (btn.classList.contains('event-grid-subnav')) {
                insertAfter(btn, document.querySelector('.section--banner'));
              } else if (btn.classList.contains('featured-wine-page')) {
                insertAfter(btn, document.querySelector('.form-block'));
              } else if (btn.classList.contains('regular-page')) {
                insertAfter(btn, document.querySelector('.section--banner'));
              } else if (btn.classList.contains('wines-grid-subnav')) {
                originalParent.insertBefore(btn, originalParent.firstChild); // Make btn the first child
              } else {
                originalParent.appendChild(btn); // Fallback to original parent
              }
            },
            onLeaveBack: () => {
              // Move it back to its original position based on class
              if (btn.classList.contains('wine-pdp')) {
                insertAfter(btn, document.querySelector('.section--wines-banner'));
              } else if (btn.classList.contains('event-grid-subnav')) {
                insertAfter(btn, document.querySelector('.section--banner'));
              } else if (btn.classList.contains('featured-wine-page')) {
                insertAfter(btn, document.querySelector('.form-block'));
              } else if (btn.classList.contains('regular-page')) {
                insertAfter(btn, document.querySelector('.section--banner'));
              } else if (btn.classList.contains('wines-grid-subnav')) {
                originalParent.insertBefore(btn, originalParent.firstChild); // Make btn the first child
              } else {
                originalParent.appendChild(btn); // Fallback to original parent
              }
            },
            //markers: true
          },
        });
      });

      if ($('.js-subNav').hasClass('wine-pdp')) {
        $('.js-subNav').insertAfter('.section--wines-banner');
      }
      if ($('.js-subNav').hasClass('event-grid-subnav')) {
        $('.js-subNav').insertAfter('.section--banner');
      }
      if ($('.js-subNav').hasClass('featured-wine-page')) {
        $('.js-subNav').insertAfter('.form-block');
      } else if ($('.js-subNav').hasClass('regular-page')) {
        $('.js-subNav').insertAfter('.section--banner');
      }
    }
  },
  activeSubNav: function () {
    if ($('.js-subNav')[0]) {
      // Function to add ScrollTrigger for each section
      function activateNavOnScroll() {
        // Get all the anchor links inside sub-navs
        const navLinks = window.innerWidth > 768 ? document.querySelectorAll('.sub-navs .desktop-links a') : document.querySelectorAll('.sub-navs a'); // Use '.sub-navs a' for smaller screens

        let lastActiveLink = null; // To store the last active link

        // Helper function to set active link and remove it from others
        function setActiveLink(activeLink) {
          // Only update if it's not already the last active link
          // if (lastActiveLink !== activeLink) {
          //     navLinks.forEach(link => link.classList.remove("active")); // Remove active class from all links
          //     activeLink.classList.add("active"); // Add active class to the current link
          //     lastActiveLink = activeLink; // Update the last active link

          // }
          navLinks.forEach((link) => link.classList.remove('active')); // Remove active class from all links
          activeLink.classList.add('active'); // Add active class to the current link
          lastActiveLink = activeLink; // Update the last active link
        }

        navLinks.forEach((link, index) => {
          const targetId = link.getAttribute('href').substring(1); // Get the ID from href attribute
          const targetSection = document.getElementById(targetId);

          if (targetSection) {
            // Create ScrollTrigger for each section
            ScrollTrigger.create({
              trigger: targetSection,
              //markers: true,
              //start: window.innerWidth > 768 ? "top center" : "top 40%", // Adjust start position based on screen size
              start: 'top center', // When the top of the section hits the center of the viewport
              end: 'bottom center', // When the bottom of the section hits the center of the viewport
              onEnter: () => {
                setActiveLink(link);
              },
              onEnterBack: () => {
                // Only set active link if it's not already active
                // if (!link.classList.contains("active")) {
                //     setActiveLink(link);
                // } else {
                //     // Ensure the active class remains if it's already active
                //     link.classList.add("active");
                // }
                //link.classList.add("active");
                setActiveLink(link);
              },
              onLeave: () => {
                // Remove active class when leaving the section
                link.classList.remove('active');
              },
              onLeaveBack: () => {
                link.classList.remove('active');
              },
            });
          }
        });

        // Ensure the first section is active initially if page loads and scroll position is past the top
        // const firstSection = document.querySelector('.sub-navs a');
        // if (window.scrollY === 0 && firstSection) {
        // firstSection.classList.add("active");
        // lastActiveLink = firstSection;
        // }
      }

      // Call the function
      activateNavOnScroll();
    }
  },
  mobileSubNavDropdown: function () {
    const dropdownToggle = document.querySelector('.dropdown-toggle');
    const dropdownMenu = document.querySelector('.dropdown-menu');
    const currentSection = document.querySelector('.current-section');
    const links = document.querySelectorAll('.sub-navs a');
    const subNav = document.querySelector('.js-subNav');

    // Handle dropdown toggle
    if (dropdownToggle && dropdownMenu) {
      dropdownToggle.addEventListener('click', () => {
        dropdownToggle.classList.toggle('active');
        dropdownMenu.classList.toggle('active');
        $('.close-filter-text').toggleClass('active');
      });
    }

    // Handle link clicks
    if (links) {
      links.forEach((link) => {
        link.addEventListener('click', (e) => {
          //e.preventDefault();

          // Close dropdown menu
          if (dropdownToggle && dropdownMenu) {
            dropdownToggle.classList.remove('active');
            dropdownMenu.classList.remove('active');
          }

          // Get target section
          const targetId = link.getAttribute('href').substring(1);
          const targetSection = document.getElementById(targetId);

          if (targetSection) {
            // Calculate scroll position using getBoundingClientRect()
            const offset = subNav ? subNav.offsetHeight : 0;
            const rect = targetSection.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const targetPosition = scrollTop + rect.top - offset;

            // Smooth scroll
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth',
            });
          }
        });
      });

      // Update active states
      const updateActiveStates = (activeLink) => {
        if (!activeLink) return;

        // Update dropdown menu links
        const dropdownLinks = document.querySelectorAll('.dropdown-menu a');
        dropdownLinks.forEach((dropdownLink) => {
          dropdownLink.classList.toggle('active', dropdownLink.getAttribute('href') === activeLink.getAttribute('href'));
        });

        // // Update current section text
        // if (currentSection) {
        //     currentSection.textContent = activeLink.textContent;
        // }
      };

      // Watch for active class changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'class') {
            const activeLink = document.querySelector('.sub-navs a.active');
            if (activeLink) {
              updateActiveStates(activeLink);
            }
          }
        });
      });

      // Observe each link for changes
      const observerConfig = { attributes: true };
      links.forEach((link) => {
        observer.observe(link, observerConfig);
      });
    }
  },
  clubLevelsDropdown: function () {
    if ($('.js-clubLevelsDropdown').length) {
      const dropdownToggles = document.querySelectorAll('.club-dropdown-toggle');
      const dropdownMenus = document.querySelectorAll('.club-dropdown-menu');

      dropdownToggles.forEach((dropdownToggle, index) => {
        const dropdownMenu = dropdownMenus[index]; // Get the corresponding dropdown menu
        if (dropdownToggle && dropdownMenu) {
          dropdownToggle.addEventListener('click', () => {
            dropdownToggle.classList.toggle('active');
            dropdownMenu.classList.toggle('active');
          });
        }
      });
    }
  },
  mobileFooterSubNav: function () {
    if ($(window).width() < 769 || Util.isTablet()) {
      $('.footer-links .link p.eyebrow').on('click', function () {
        $(this).parent().toggleClass('active');
      });
    }
  },
  winesBanner: function () {
    // Handle thumbnail clicks in wines banner module
    $('.wines-banner-module .thumbnail').on('click', function () {
      // Remove active class from all thumbnails in this module
      $('.wines-banner-module .thumbnail').removeClass('active');
      // Add active class to clicked thumbnail
      $(this).addClass('active');

      const mediaUrl = $(this).data('media-url');
      const mediaType = $(this).data('media-type');
      const mediaAlt = $(this).data('media-alt');
      const activeMediaContainer = $(this).closest('.wines-banner-module').find('.active-media');

      // Clear the active media container
      activeMediaContainer.empty();

      // Add new media based on type
      if (mediaType === 'video') {
        const video = `
                    <video controls autoplay muted loop playsinline>
                        <source src="${mediaUrl}" type="video/${mediaUrl.split('.').pop()}">
                        Your browser does not support the video tag.
                    </video>
                `;
        activeMediaContainer.html(video);
      } else {
        const img = `<img src="${mediaUrl}" alt="${mediaAlt}">`;
        activeMediaContainer.html(img);
      }
    });
  },
  treeAnimation: function () {
    let images = document.querySelectorAll('.js-tree-animation');
    if (images.length > 0) {
      images.forEach((item, index) => {
        let paths = item.querySelectorAll('path');
        paths.forEach((path, pathIndex) => {
          path.id = 'ring' + (index + 1) + '_' + (pathIndex + 1);
        });

        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: item,
            start: `${item.dataset.start} 50%`,
            end: '+50%',
            //markers: true,
            once: true,
            // toggleClass: 'active',
          },
        });

        tl.fromTo(paths, { autoAlpha: 0 }, { autoAlpha: 1, duration: 1 });

        // paths.forEach((path, pathIndex) => {
        //   gsap.set(`#ring${index + 1}_${pathIndex + 1}`, { drawSVG: 0 }); // Clear the path initially
        //   tl.to(
        //     `#ring${index + 1}_${pathIndex + 1}`,
        //     {
        //       drawSVG: '100%',
        //       duration: 1,
        //       ease: 'power4.Out',
        //     },
        //     `-=.8`
        //   ); // Draw the path over 1 second, after a 0.5 second delay
        // });

        // let startTime = 0; // Define the start time for all animations
        // paths.forEach((path, pathIndex) => {
        //   gsap.set(`#ring${index + 1}_${pathIndex + 1}`, { drawSVG: 0 }); // Clear the path initially
        //   tl.to(
        //     `#ring${index + 1}_${pathIndex + 1}`,
        //     {
        //       drawSVG: '100%',
        //       duration: 0.6 + pathIndex * 0.35, // Increase duration for each path
        //       ease: 'power4.Out',
        //     },
        //     startTime // Start all animations at the same time
        //   );
        // });
      });
    }
  },
  shopAllWinesDropdown: function () {
    if ($('.js-shopALlWinesDropdown').length) {
      $('.dropdown-trigger .dropdown-arrow').each(function () {
        $(this).on('click', function () {
          // Toggle active class on the clicked trigger
          $(this).parent().toggleClass('active');

          // Toggle the dropdown content
          $(this).parent().next('.dropdown-content').slideToggle(300);

          // Toggle the arrow rotation
          $(this).parent().find('.dropdown-arrow').toggleClass('rotate');
        });
      });

      // Close dropdowns when clicking outside
      // $(document).on('click', function(e) {
      //     if (!$(e.target).closest('.filters__group').length) {
      //         $('.dropdown-content').slideUp(300);
      //         $('.dropdown-trigger').removeClass('active');
      //         $('.dropdown-arrow').removeClass('rotate');
      //     }
      // });
    }
    if ($('.js-shopWinesTrigger')[0]) {
      function insertAfter(newNode, referenceNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
      }
      const subnav = gsap.utils.toArray('.js-shopWinesTrigger');

      subnav.forEach((btn) => {
        const originalParent = btn.parentNode; // Store the original parent
        gsap.from(btn, {
          scrollTrigger: {
            start: 'top top',
            end: 'top bottom',
            trigger: btn,
            endTrigger: '.footer',
            toggleClass: 'fixed',
            onEnter: () => {
              document.getElementById('smooth-wrapper').parentNode.appendChild(btn);
            },
            onEnterBack: () => {
              document.getElementById('smooth-wrapper').parentNode.appendChild(btn);
            },
            onLeave: () => {
              originalParent.appendChild(btn); // Fallback to original parent
            },
            onLeaveBack: () => {
              originalParent.appendChild(btn); // Fallback to original parent
            },
            //markers: true
          },
        });
      });
    }
  },
  introVideoLoader: function () {
    if ($('.js-introVideoLoader')[0]) {
      const video = document.querySelector('.js-introVideoLoader');
      const svgCircleProgressIntro = document.getElementById('svgCircleProgressIntro');
      const svgCircleProgressPathIntro = document.getElementById('svgCircleProgressPathIntro');
      let tween = null; // Initialize tween to null
      let percentElement = false;
      const circleLoader = gsap.timeline({ paused: true });
      TweenMax.set(svgCircleProgressPathIntro, { drawSVG: 0 });

      let videoDuration = '';

      video.addEventListener('loadedmetadata', function () {
        videoDuration = video.duration;
        console.log('Video duration: ' + videoDuration); // Log the updated duration
        start(); // Call the start function after the duration is set
      });

      function start() {
        // Now you can use videoDuration here
        console.log('Inside start function, video duration: ' + videoDuration);
        tween = TweenMax.fromTo(
          svgCircleProgressPathIntro,
          videoDuration,
          {
            drawSVG: '0',
          },
          {
            drawSVG: '0 100%',
            onComplete: repeat,
          }
        );
      }
      function repeat() {
        start();
        // using setTimeout to give a bit of a delay before re-drawing the circle
        //setTimeout(start);
      }

      //start();

      $('.intro-module__grid-left .pause-btn').on('click', function () {
        if (!$(this).hasClass('paused')) {
          video.pause();
          tween.pause();
          $(this).addClass('paused');
        } else {
          video.play();
          tween.play();
          $(this).removeClass('paused');
        }
      });
    }
  },
  teamMembers: function () {
    if ($('.js-teamMembers')[0]) {
      $('.team-module__item').on('click', function () {
        $('.modal').removeClass('open');
        const dataIndex = $(this).data('index');
        $('.modal[data-index="' + dataIndex + '"]').addClass('open');

        let calculatedOrder;

        if ($(window).width() >= 1280) {
          // Check if it's desktop
          calculatedOrder = 4 * Math.ceil(dataIndex / 4); // Calculate order based on dataIndex

          const modalElement = $('.modal[data-index="' + dataIndex + '"]');
          openModalAndScroll(modalElement); // Call the new function
        } else if ($(window).width() >= 992) {
          calculatedOrder = 3 * Math.ceil(dataIndex / 3); // For mobile, use dataIndex + 1
        } else {
          $('.sub-navs').hide();
          $('header').hide();
          calculatedOrder = dataIndex; // For mobile, use dataIndex + 1
          // Prevent page scrolling
          $('body').css({
            'overflow': 'hidden',
            'position': 'fixed',
            'width': '100%', // Ensure the body takes full width
          });
        }
        $('.modal[data-index="' + dataIndex + '"]').css('order', calculatedOrder);
      });
      $('.modal .close-btn').on('click', function () {
        $('.modal').removeClass('open');

        if ($(window).width() < 992) {
          $('.sub-navs').show();
          $('header').show();
          $('body').css('overflow', 'auto');
          $('body').css('position', 'relative');
          $('html, body').scrollTop($(this).parent().parent().offset().top);
        }
      });
    }
  },
  appellationModals: function () {
    if ($('.js-appellationModals')[0]) {
      $('.appellation-item').on('click', function () {
        $('.modal').removeClass('open');
        const dataIndex = $(this).data('index');
        $('.modal[data-index="' + dataIndex + '"]').addClass('open');

        let calculatedOrder;
        //calculatedOrder = 2 * Math.ceil(dataIndex / 2); // Calculate order based on dataIndex

        if ($(window).width() >= 992) {
          // Check if it's desktop
          calculatedOrder = 2 * Math.ceil(dataIndex / 2); // Calculate order based on dataIndex

          const modalElement = $('.modal[data-index="' + dataIndex + '"]');
          openModalAndScroll(modalElement); // Call the new function
        } else {
          $('.sub-navs').hide();
          $('header').hide();
          calculatedOrder = dataIndex; // For mobile, use dataIndex + 1
          // Prevent page scrolling
          $('body').css({
            'overflow': 'hidden',
            'position': 'fixed',
            'width': '100%', // Ensure the body takes full width
          });
        }
        $('.modal[data-index="' + dataIndex + '"]').css('order', calculatedOrder);
      });
      $('.modal .close-btn').on('click', function () {
        $('.modal').removeClass('open');
        if ($(window).width() < 992) {
          $('.sub-navs').show();
          $('header').show();
          $('body').css('overflow', 'auto');
          $('body').css('position', 'relative');
          $('html, body').scrollTop($(this).parent().parent().offset().top);
        }
      });
    }
  },
  linksScroll: function () {
    $('a[href^="#"]:not(.show-cart-btn)').on('click', function (e) {
      console.log('clicked');
      e.preventDefault();
      const target = $(this).attr('href');
      const targetElement = document.querySelector(target);

      if (targetElement) {
        // Calculate the position of the target element
        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;

        // Adjust the position for mobile devices
        let adjustedPosition;
        if (window.innerWidth < 768) {
          // Check if the device is mobile
          const headerHeight = $('header').outerHeight() || 0; // Get header height
          adjustedPosition = targetPosition - 250; // Adjust for mobile
        } else {
          adjustedPosition = targetPosition - 300; // No adjustment for desktop
        }

        gsap.to(window, {
          duration: 1,
          scrollTo: {
            y: adjustedPosition,
            autoKill: false, // Prevents auto-killing of the animation
          },
        });
      }
    });
  },
  winesStickyNav: function () {
    if ($('.js-winesStickyNav')[0]) {
      const stickyNav = document.querySelector('.js-winesStickyNav');
      const stickyNavOffset = stickyNav.offsetTop;

      if ($(window).width() < 768) {
        ScrollTrigger.create({
          trigger: stickyNav,
          end: 'top 80%',
          endTrigger: '.footer',
          //markers: true,
          onEnter: () => {
            gsap.to(stickyNav, {
              y: 0,
              duration: 0.5,
              ease: 'power2.out',
            });
          },
          onEnterBack: () => {
            gsap.to(stickyNav, {
              y: 0,
              duration: 0.5,
              ease: 'power2.out',
            });
          },
          onLeave: () => {
            gsap.to(stickyNav, {
              y: '100%',
              duration: 0.5,
              ease: 'power2.out',
            });
          },
          onLeaveBack: () => {
            gsap.to(stickyNav, {
              y: '100%',
              duration: 0.5,
              ease: 'power2.out',
            });
          },
        });
      } else {
        ScrollTrigger.create({
          trigger: stickyNav,
          start: 'top 80%',
          end: 'top 80%',
          endTrigger: '.footer',
          //markers: true,
          onEnter: () => {
            gsap.to(stickyNav, {
              y: 0,
              duration: 0.5,
              ease: 'power2.out',
            });
          },
          onLeave: () => {
            gsap.to(stickyNav, {
              y: '100%',
              duration: 0.5,
              ease: 'power2.out',
            });
          },
          onEnterBack: () => {
            gsap.to(stickyNav, {
              y: 0,
              duration: 0.5,
              ease: 'power2.out',
            });
          },
          onLeaveBack: () => {
            gsap.to(stickyNav, {
              y: '100%',
              duration: 0.5,
              ease: 'power2.out',
            });
          },
        });
      }
    }
  },
  init: function () {
    this.activeSubNav();
    this.sideMenu();
    this.headerAnimation();
    //this.fadeIn();
    this.subNav();
    this.mobileFooterSubNav();
    this.winesBanner();
    this.treeAnimation();
    this.mobileSubNavDropdown();
    this.shopAllWinesDropdown();
    //this.exploreControl();
    this.introVideoLoader();
    this.clubLevelsDropdown();
    this.teamMembers();
    this.appellationModals();
    this.linksScroll();
    this.winesStickyNav();
  },
};

//Load the anchor for a smooth scroll
document.addEventListener('DOMContentLoaded', function () {
  const anchorToScroll = sessionStorage.getItem('scrollToAnchor');

  if (anchorToScroll) {
    // Temporarily disable smooth scroll
    const styleTag = document.createElement('style');
    styleTag.innerHTML = `html { scroll-behavior: auto !important; }`;
    document.head.appendChild(styleTag);

    setTimeout(function () {
      const targetElement = document.getElementById(anchorToScroll);

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'auto',
          block: 'start',
        });

        // Restore smooth scrolling after scroll action
        setTimeout(function () {
          document.head.removeChild(styleTag);
        }, 100);
      }

      // Clear the stored anchor after use
      sessionStorage.removeItem('scrollToAnchor');
    }, 500); // Delay to ensure the DOM is fully rendered
  }
});

function openModalAndScroll(modalElement) {
  if (modalElement.length) {
    // Open the modal first
    modalElement.addClass('open');

    // Use a timeout to ensure the modal is fully opened before scrolling
    setTimeout(() => {
      const offset = 20; // Adjust this value for desired padding
      const elementPosition = modalElement.offset().top;
      const offsetPosition = elementPosition - offset;

      $('html, body').stop().animate({ scrollTop: offsetPosition }, 500); // Smooth scroll
    }, 100); // Delay to ensure the modal is visible
  }
}

export default Animations;
